// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"41115e23","453":"16603536","455":"cd6b0087","726":"eb52d6d0","977":"c49f0909"}[chunkId] + ".chunk.js";
};